import { ref, createApp } from 'vue'
import Toast from '@/components/Toast.vue'

interface ToastOptions {
    type?: 'success' | 'error' | 'warning' | 'info'
    title: string
    message?: string
    duration?: number
    autoClose?: boolean
}

const toasts = ref<Array<{ id: number; component: any }>>([])
let toastId = 0

export const useToast = () => {
    const showToast = (options: ToastOptions) => {
        const id = ++toastId

        // 创建容器
        const container = document.createElement('div')
        container.id = `toast-${id}`
        document.body.appendChild(container)

        // 创建 Toast 组件实例
        const app = createApp(Toast, {
            ...options,
            onClose: () => {
                app.unmount()
                document.body.removeChild(container)
                toasts.value = toasts.value.filter(t => t.id !== id)
            }
        })

        app.mount(container)

        toasts.value.push({ id, component: app })
    }

    const success = (title: string, message?: string) => {
        showToast({ type: 'success', title, message })
    }

    const error = (title: string, message?: string) => {
        showToast({ type: 'error', title, message })
    }

    const warning = (title: string, message?: string) => {
        showToast({ type: 'warning', title, message })
    }

    const info = (title: string, message?: string) => {
        showToast({ type: 'info', title, message })
    }

    return {
        showToast,
        success,
        error,
        warning,
        info
    }
}

// 全局方法
export const toast = {
    success: (title: string, message?: string) => useToast().success(title, message),
    error: (title: string, message?: string) => useToast().error(title, message),
    warning: (title: string, message?: string) => useToast().warning(title, message),
    info: (title: string, message?: string) => useToast().info(title, message)
}